<div class="requisites-modal">
  <header class="requisites-modal__header">
    <h2 class="requisites-modal__title">Получить счёт на оплату</h2>
    <button class="requisites-modal__close" type="button" (click)="close()" aria-label="Закрыть">
      <i class="icon-close"></i>
    </button>
  </header>

  <div class="requisites-modal__body">
    <div class="requisites-modal__summary">
      <div class="requisites-modal__summary-text">
        <p class="requisites-modal__summary-name">{{ data.tariffName }}</p>
        <p class="requisites-modal__summary-period">{{ data.periodLabel }}</p>
      </div>
      <p class="requisites-modal__summary-price">{{ data.priceLabel }}</p>
    </div>

    <company-requisites-form
      #form
      class="requisites_figma"
      [hideChrome]="true"
      (saved)="onSaved()">
    </company-requisites-form>
  </div>

  <footer class="requisites-modal__footer">
    <button type="button"
            class="button button_theme-1 requisites-modal__cta"
            [disabled]="form.form.invalid"
            (click)="form.submit()">
      Получить счёт в PDF
    </button>
  </footer>
</div>
